import axios from 'axios'
import { ElMessage } from 'element-plus'
import { useUserStore } from '@/stores/user'
import { useAdminStore } from '@/stores/admin'

const request = axios.create({
  baseURL: (import.meta as any).env.VITE_APP_API_BASE_URL || '/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
})

request.interceptors.request.use(
  (config) => {
    // 区分管理端和客户端请求，携带不同的 token
    if (config.url?.startsWith('/admin')) {
      const adminStore = useAdminStore()
      if (adminStore.token) {
        config.headers.Authorization = `Bearer ${adminStore.token}`
      }
    } else {
      const userStore = useUserStore()
      if (userStore.token) {
        config.headers.Authorization = `Bearer ${userStore.token}`
      }
      if (userStore.currentCityCode) {
        config.headers['X-City-Code'] = userStore.currentCityCode
      }
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

request.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    const { response, config } = error
    
    if (response?.status === 401) {
      if (config.url?.startsWith('/admin')) {
        const adminStore = useAdminStore()
        adminStore.logout()
        window.location.href = '/admin/login'
      } else {
        const userStore = useUserStore()
        userStore.logout()
        window.location.href = '/login'
      }
      
      const msg = response.data?.msg || '登录已过期，请重新登录'
      ElMessage.error({ message: msg, duration: 3000, plain: true })
    }
    
    return Promise.reject(error)
  }
)

export default request
